<div class="row product-list-item-doc" *ngIf="!isMobile && product">
   <div class="col-12 col-md-5">
      <div class="d-flex">
         <div class="product-code" [innerHtml]="product.code  | searchHighlight:searchQuery "></div>

         <ng-container *ngIf="isLoggedIn">
            <div (click)="addfav = !addfav" (mouseenter)="tooltip = true" (mouseleave)="tooltip = false">
               <img *ngIf="tooltip" (click)="SubscribeDoc(product)"
                  [attr.src]="tooltip ? '/icons/icon_star_active.svg' : '/icons/icon_star.svg'" alt=""
                  class="icon-star">
               <img *ngIf="!tooltip" [attr.src]="addfav ? '/icons/icon_star_active.svg' : '/icons/icon_star.svg'" alt=""
                  class="icon-star">
               <span class="tooltip-AddtoFavorites" *ngIf="tooltip">{{'common.text_favorite_to_add'|cxTranslate}}
               </span>
            </div>
         </ng-container>
      </div>
      <div class="doc-type" [innerHTML]="product.description  | searchHighlight:searchQuery "></div>
      <div class="doc-type category"
         [innerHTML]="(product.productCategory && product.productCategory.length)?  (product?.productCategory[0] | searchHighlight:searchQuery)  : ''">
      </div>
      <div class="doc-type" [innerHTML]="product.docType  | searchHighlight:searchQuery "></div>
   </div>
   <div class="d-flex col-12 col-md-7 document-col-end">
      <div class="d-flex flex-column col-md-6">
         <label class="doc-lang">{{'common.document_text_language'|cxTranslate}}<span
               [innerHTML]="product.language"></span></label>
         <label class="doc-revision">{{'common.document_text_revision'|cxTranslate}}<span
               [innerHTML]="product.revision"></span></label>
         <label class="doc-releasedate">{{'common.document_text_releaseDate'|cxTranslate}}<span
               [innerHTML]="product.releaseDate"></span></label>
      </div>

      <div class="download-btn-outer" *ngIf="product?.fileName?.toLowerCase()?.includes('.url');else download">
         <div class="dowload-btn-outer">
            <a href="{{product.url}}" target="_blank" class="btn btn-primary-new btn-launch-new" rel="noopener">
               {{'common.document_video_launch_btn' | cxTranslate }}
               <img src="/icons/link-grey.svg" class="icon-right" alt="video launch" />
            </a>
         </div>
      </div>
      <ng-template #download>
         <div class="download-btn-outer">
            <a (click)="callApi(product);" target="_blank" class="btn btn-primary-new ">
               {{'common.document_download_btn'|cxTranslate}}
               <img src="/icons/link-grey.svg" class="icon-right" alt="document download">
            </a>
         </div>

      </ng-template>

   </div>
</div>
<div *ngIf="isMobile && product">
   <div class="details">
      <div class="product-description">

         <label class="product-code" [innerHtml]="product.code"></label>

         <div class="doc-desc" [innerHTML]="product.description"></div>
         <div class="doc-type"
            [innerHTML]="(product.productCategory && product.productCategory.length)?  product?.productCategory[0] : ''">
         </div>
         <div class="doc-normal-text">[{{product.docTypeCode}}]</div>
         <div class="doc-docType" [innerHTML]="product.docType"></div>

         <div>{{'common.document_text_language'|cxTranslate}}{{product.language}}</div>
         <div>{{'common.document_text_revision'|cxTranslate}}{{product.revision}}</div>
         <div>{{'common.document_text_releaseDate'|cxTranslate}}{{product.releaseDate}}</div>
         <div class="download-btn-outer" *ngIf="(product?.fileName?.toLowerCase()?.includes('.url'));else download">
            <div class="download-btn-outer">
               <a href="{{product.url}}" target="_blank" class="btn button-launch" rel="noopener">
                  {{'common.document_video_launch_btn' | cxTranslate }}
               </a>
            </div>
         </div>
         <ng-template #download>
            <div class="download-btn-outer">
               <p>{{product.url}}=======</p>
               <a (click)="callApi(product)" target="_blank" class="btn button">
                  {{'common.document_download_btn'|cxTranslate}}
                  <img src="/icons/link-white.svg" class="icon-right" alt="">
               </a>
            </div>

         </ng-template>
      </div>
   </div>
</div>